import { formatPrice } from '@rocco/utils/format-price';
import type { Currency } from '../type/types';

export const proposalFormatPrice = (price: number, currency: Currency) => {
    return formatPrice(price, currency, 'CC$ 0.00');
};
